import { render, staticRenderFns } from "./BetgameUsersTable.vue?vue&type=template&id=226a5866&scoped=true"
import script from "./BetgameUsersTable.vue?vue&type=script&lang=js"
export * from "./BetgameUsersTable.vue?vue&type=script&lang=js"
import style0 from "./BetgameUsersTable.vue?vue&type=style&index=0&id=226a5866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226a5866",
  null
  
)

export default component.exports